import { useState, useEffect } from "react";
import ReactGA from 'react-ga';
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import { getRefreshTokenCookie } from "lib/Storage";

import Portrait from "components/Portrait";
import { Navigate } from "react-router-dom";

function PortraitBase() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  const [audioContextInstance, setAudioContextInstance] = useState(
    new AudioContext()
  );
  const [isPortrait, setIsPortrait] = useState(
    window.innerHeight >= window.innerWidth
  );

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight >= window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(()=>{
    let refreshTokenExists = getRefreshTokenCookie()
    if(!refreshTokenExists){
      // eslint-disable-next-line no-restricted-globals
      location.href="/auth";
    }
  },[])

  return isPortrait ? (
    <Portrait audioContextInstance={audioContextInstance} />
  ) : (
    <Navigate to="/" />
  );
  // <DeviceOrientation lockOrientation={"landscape"}>
  //   {/* Will only be in DOM in landscape */}
  //   <Orientation orientation="landscape" alwaysRender={false}>
  //     <Redirect to="/" />
  //   </Orientation>
  //   {/* Will stay in DOM, but is only visible in portrait */}
  //   <Orientation orientation="portrait" alwaysRender={false}>
  //     <Portrait audioContextInstance ={audioContextInstance} />
  //   </Orientation>
  // </DeviceOrientation>
}

export default PortraitBase;
